import React from "react";
import styled, { css } from "styled-components";
import { rem } from "polished";
import mq from "../../helpers/media-queries";
import QuoteModal from "../QuoteModal/QuoteModal";
import StockStatus from "../StockStatus/StockStatus";
import Truck from "../../assets/img/truck.svg";
import Lock from "../../assets/img/lock.svg";
import Cards from "../../assets/img/cards.png";

const Button = styled.button`
	background: #cc6f4c;
	width: 100%;
	padding: ${rem(14)};
	border: 0;
	appearance: none;
	color: white;
	font-size: 20px;
	border-radius: 5px;
	cursor: pointer;
	font-family: sans-serif;
	transition: 0.3s;

	&:hover {
		background: #231914;
	}

	&[disabled] {
		opacity: 0.2;
		cursor: not-allowed;
	}

	${({ outlined }) =>
		outlined &&
		css`
			background: white;
			color: #000;
			box-shadow: inset 0 0 0 2px #000;
		`}

	&:focus {
		outline: none;
	}
`;

const SidebarBottom = styled.div`
	background: #f9f9f9;
	height: auto;
	width: 100%;
	border-top: 1px solid #eaeaea;
	color: #181b20;

	${mq("sm", "max")} {
		padding: ${rem(15)} ${rem(17)} ${rem(15)} ${rem(17)};
	}

	${mq("sm", "min")} {
		padding: ${rem(20)} ${rem(40)} ${rem(30)} ${rem(40)};
	}
`;

const DeliveryNote = styled.div`
	padding-bottom: ${rem(16)};
	border-bottom: 1px solid #dbdbdb;
	font-size: ${rem(15)};
	line-height: 1.5;
	display: flex;
	color: #282a2c;
	font-family: sans-serif;

	a {
		color: #2d71b6;
		text-decoration: none;
		position: relative;
		margin-left: ${rem(10)};
		padding-left: ${rem(10)};

		&::before {
			content: "";
			position: absolute;
			height: 14px;
			width: 1px;
			top: 50%;
			transform: translateY(-50%);
			background: #000;
			opacity: 0.2;
			left: 0;
		}
	}
`;

const PriceContainer = styled.div`
	font-size: ${rem(15)};
	font-family: sans-serif;
	display: flex;
	margin-top: ${rem(10)};
	margin-bottom: ${rem(10)};
	align-items: flex-end;
`;

const Price = styled.span`
	font-size: ${rem(20)};
	margin-left: ${rem(7)};
	margin-bottom: ${rem(-2)};
`;

const Details = styled.div`
	margin-top: ${rem(17)};
	display: flex;
	justify-content: space-between;

	a {
		color: #2d71b6;
		font-family: sans-serif;
		font-size: ${rem(15)};
		line-height: 1.5;
		text-decoration: none;
	}
`;

const FinalStepButtons = styled.div`
	${Button}:not(:last-of-type) {
		margin-bottom: ${rem(13)};
	}
`;

const TopButtons = styled.div`
	padding-bottom: ${rem(16)};
	padding-top: ${rem(10)};
`;

const Shipping = styled.div`
	font-weight: 400;
	font-size: ${rem(15)};
	line-height: ${rem(18)};
	font-family: sans-serif;
`;
const Flex = styled.div`
	display: flex;
	align-items: center;
	margin-top: ${rem(7)};
	img {
		width: ${rem(19)};
		max-height: ${rem(15)};
		margin-right: ${rem(10)};
		object-fit: contain;
	}
	.cards {
		width: ${rem(83)};
		max-height: 100vh;
		margin-left: ${rem(5)};
	}
`;

const Bottom = ({
	isOverview,
	isCheckout,
	isDisabled,
	nextStep,
	nextTitle,
	title,
	onAddToCart,
	inStock,
	showDetails,
}) => {
	return (
		<SidebarBottom>
			{isCheckout && (
				<React.Fragment>
					<FinalStepButtons>
						<Button disabled={isDisabled} onClick={onAddToCart}>
							Add to Cart
						</Button>
					</FinalStepButtons>
				</React.Fragment>
			)}
			{!isOverview && !isCheckout && (
				<TopButtons>
					<Button disabled={isDisabled} onClick={nextStep}>
						Continue to {nextTitle}
					</Button>
				</TopButtons>
			)}

			{isOverview && (
				<React.Fragment>
					<FinalStepButtons>
						<QuoteModal title={title} onAddToCart={onAddToCart} />
						{/* <Button outlined>Save as PDF</Button> */}
					</FinalStepButtons>

					{/* <Details>
						<a href="https://www.google.com/" target="_blank" rel="noreferrer">
							Delivery details
						</a>

						<a href="https://www.google.com/" target="_blank" rel="noreferrer">
							Terms and conditions
						</a>
					</Details> */}
				</React.Fragment>
			)}

			{inStock && (
				<StockStatus
					uppercase={true}
					inStock={true}
					shippingInfo={"ships out in 1-3 days"}
				/>
			)}
			{showDetails && (
				<Shipping>
					<Flex>
						<img src={Truck} alt="" />
						<p>Nationwide UK delivery</p>
					</Flex>
					<Flex>
						<img src={Lock} />
						<p>100% Secure transaction</p>
						<img className="cards" src={Cards} />
					</Flex>
				</Shipping>
			)}
		</SidebarBottom>
	);
};

export default Bottom;
